import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/reset.css'; // CSS 경로 확인
import store from './store'; // Vuex store import
import { createHead } from '@vueuse/head'; // @vueuse/head import


const app = createApp(App);
const head = createHead(); // Head Manager 생성

app.use(head); // Head Manager 추가
app.use(router); // Router 사용
app.use(store); // Vuex 사용
app.mount('#app');